import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReCaptcha from 'react-google-recaptcha'
import './style.css'


export default class AppCaptcha extends Component {
    static propTypes = {
        className: PropTypes.string,
        setAppCaptcha: PropTypes.func.isRequired
    }

    static  defaultProps = {
        className: ''
    }

    componentDidMount() {
        this.props.setAppCaptcha(null)
    }

    onCaptchaChange = (token) => {
        this.props.setAppCaptcha(token)
    }

    render() {
       return (
            <ReCaptcha
                onChange={(token) => this.onCaptchaChange(token)}
                className={`captcha ${this.props.className}`}
                sitekey='6LdJOkUUAAAAAKzrfL_wuQM-cNZ0jnTQqLuFyFVt'
            />
        )
    }
}
